export default {
  // font: font-style font-variant font-weight font-size/line-height font-family;
  body: `font: normal normal 300 1.25rem Roboto;`,
  heading: `font: normal normal 500 1.5rem/1 "Bebas Neue";`,
  button: `font: normal normal 500 1.2rem/1 "Bebas Neue";`,
  handwriting: `font: normal normal 400 2rem/1 "Reenie Beanie", cursive;`,
};
